import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Avatar from "@mui/material/Avatar";
import {
  CardHeader, Pagination, Button, InputBase,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import React, { useState, useEffect } from "react";
import api from "../../../config/api";

// Styled components for search bar
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.black, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
      '&:focus': {
        width: '28ch',
      },
    },
  },
}));

const Customers = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [isSearching, setIssearching] = useState("");

  const loadUsers = async () => {
    try {
      const response = await api.get("/api/users");
      const allUsers = response.data || [];
      setUsers(Array.isArray(allUsers) ? allUsers : []);
    } catch (err) {
      console.log(err.message);
      setUsers([]);
    }
  };

  useEffect(() => {

    loadUsers();
  }, []);

  const fetchCustomer = async () => {
    try {
      const response = await api.get(`/api/users/SearchCustomer`, {
        params: { name: searchName },
      });
      setUsers(response.data.data);
    } catch (err) {
      alert("Error fetching customers");
    }
  };

  const clearDateFilters = () => {
    setSearchName("");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchCustomer();
  };

  const handlePaginationChange = (event, value) => {
    console.log("Current page:", value);
  };

  const [selectedUser, setSelectedUser] = useState(null); // For selected customer in update
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/api/users/updateuser/${selectedUser._id}`, selectedUser);
      setOpenUpdateModal(false);
      loadUsers(); // Reload users after updating
    } catch (err) {
      console.error("Error updating user:", err);
    }
  };

  const handleDeleteUser = async () => {
    try {
      await api.delete(`/api/users/deleteuser/${userToDelete._id}`);
      setOpenDeleteDialog(false);
      loadUsers(); // Reload users after deletion
    } catch (err) {
      console.error("Error deleting user:", err);
    }
  };

  const handleOpenUpdateModal = (user) => {
    setSelectedUser(user); // Set selected user for updating
    setOpenUpdateModal(true);
  };

  const handleOpenDeleteDialog = (user) => {
    setUserToDelete(user); // Set user to be deleted
    setOpenDeleteDialog(true);
  };

  const handleCloseUpdateModal = () => setOpenUpdateModal(false);
  const handleCloseDeleteDialog = () => setOpenDeleteDialog(false);


  // State for the "Add Customer" modal
  const [openAddModal, setOpenAddModal] = useState(false);
  const [newCustomer, setNewCustomer] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "ADMIN", // Default role
  });

  const handleAddCustomer = async (e) => {
    e.preventDefault();
    try {
      // Send new customer data to the API
      await api.post("/auth/signup", newCustomer);
      setOpenAddModal(false);
      loadUsers();  // Reload users after adding
    } catch (err) {
      console.error("Error adding customer:", err);
    }
  };

  return (
    <Box>
      <Card>
        <CardHeader
          title="All Customers"
          sx={{
            pt: 2,
            alignItems: "center",
            "& .MuiCardHeader-action": { mt: 0.6 },
          }}
        />
        <Button variant="contained" color="success" onClick={() => setOpenAddModal(true)} sx={{ marginLeft: '10px' }}>
          Add Admin
        </Button>
        {/* Search Input */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '20px' }}>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <form onSubmit={handleSearch}>
              <StyledInputBase
                placeholder="Search by Name…"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                inputProps={{ 'aria-label': 'search' }}
              />
            </form>
          </Search>
          <Box>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              sx={{ marginLeft: '10px', backgroundColor: '#1976d2', color: 'white' }}>
              Search
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={clearDateFilters}
              sx={{ marginLeft: '10px', borderColor: '#1976d2', color: '#1976d2' }}>
              Clear Data
            </Button>



          </Box>
        </Box>

        <TableContainer>
          <Table sx={{ minWidth: 390 }} aria-label="table in dashboard">
            <TableHead>
              <TableRow>
                <TableCell>User Id</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Mobile</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>All Customers</TableCell>
                <TableCell>Actions</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(users) && users.length > 0 ? (
                users.map((item, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{ "&:last-of-type td, &:last-of-type th": { border: 0 } }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Avatar alt={item.name} src={item.image} />
                    </TableCell>
                    <TableCell>{item.firstName} {item.lastName}</TableCell>
                    <TableCell>{item.mobile}</TableCell>
                    <TableCell>{item.email}</TableCell>
                    <TableCell>{item._id} {item.order_id}</TableCell>
                    <TableCell>{users.length}</TableCell>


                    <TableCell>
                      <Button
                        color="primary"
                        onClick={() => handleOpenUpdateModal(item)}

                      >
                        Edit
                      </Button>
                      <Button
                        color="error"
                        onClick={() => handleOpenDeleteDialog(item)}

                      >
                        Delete
                      </Button>
                    </TableCell>

                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    {isSearching ? "Searching..." : "No customers found"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
      <Card className="mt-2 flex justify-center items-center">
        <Pagination
          className="py-5 w-auto"
          size="large"
          count={10}
          color="primary"
          onChange={handlePaginationChange}
        />
      </Card>

      {/* Add Customer Modal */}
      <Dialog open={openAddModal} onClose={() => setOpenAddModal(false)}>
        <DialogTitle>Add Customer</DialogTitle>
        <DialogContent>
          <form onSubmit={handleAddCustomer}>
            <TextField
              label="First Name"
              value={newCustomer.firstName}
              onChange={(e) => setNewCustomer({ ...newCustomer, firstName: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Last Name"
              value={newCustomer.lastName}
              onChange={(e) => setNewCustomer({ ...newCustomer, lastName: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Email"
              value={newCustomer.email}
              onChange={(e) => setNewCustomer({ ...newCustomer, email: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Password"
              type="password"
              value={newCustomer.password}
              onChange={(e) => setNewCustomer({ ...newCustomer, password: e.target.value })}
              fullWidth
              margin="normal"
            />
            <Button type="submit" color="primary" variant="contained" fullWidth>
              Add Customer
            </Button>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddModal(false)} color="secondary">Cancel</Button>
        </DialogActions>
      </Dialog>



      {/* Update User Modal */}
      <Dialog open={openUpdateModal} onClose={handleCloseUpdateModal}>
        <DialogTitle>Edit Customer</DialogTitle>
        <DialogContent>
          <form onSubmit={handleUpdateUser}>
            <TextField
              label="First Name"
              value={selectedUser?.firstName || ""}
              onChange={(e) => setSelectedUser({ ...selectedUser, firstName: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Last Name"
              value={selectedUser?.lastName || ""}
              onChange={(e) => setSelectedUser({ ...selectedUser, lastName: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Email"
              value={selectedUser?.email || ""}
              onChange={(e) => setSelectedUser({ ...selectedUser, email: e.target.value })}
              fullWidth
              disabled
              margin="normal"
            />
            <TextField
              label="Mobile"
              value={selectedUser?.mobile || ""}
              onChange={(e) => setSelectedUser({ ...selectedUser, mobile: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Date of Birth"
              type="date"
              value={selectedUser?.dob || ""}
              onChange={(e) => setSelectedUser({ ...selectedUser, dob: e.target.value })}
              fullWidth
              margin="normal"
              InputLabelProps={{ shrink: true }}
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Gender</InputLabel>
              <Select
                value={selectedUser?.gender || ""}
                onChange={(e) => setSelectedUser({ ...selectedUser, gender: e.target.value })}
              >
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>


            <Button type="submit" color="primary" variant="contained" fullWidth>
              Save Changes
            </Button>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUpdateModal} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete this customer?"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="secondary">
            No
          </Button>
          <Button onClick={handleDeleteUser} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Customers;